import { TwinDictionary } from '../../../../../../../utils/globals/dictionary';

export const parseModalAccountsRowsData = (accounts: TwinDictionary) => {
    const parsedAccounts: TwinDictionary[] = []
    for (const account in accounts) {
        const element = accounts[account];
        if (element.name !== '--other') {
            parsedAccounts.push(element)
        }
    }
    return parsedAccounts
}